/* eslint-disable no-restricted-properties */
import { FunctionComponent, useEffect } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import Logo from '@/components/Header/Logo'
import { CircularLoader, Grid, Text } from '@/tbui'

const PageCover = styled(Grid)<{ isOpen: boolean }>`
  pointer-events: ${(props) => (props.isOpen ? 'auto' : 'none')};
  transform: scale(${(props): number => (props.isOpen ? 1 : 1.25)});
  background: ${(props) => props.theme.palette.WHITE};
  opacity: ${(props): number => (props.isOpen ? 1 : 0)};
  transition: 0.25s ease;
  position: fixed;
  z-index: 999;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`

interface ProcessingModalProps {
  onConfirm: () => void
  open: boolean
}
const ProcessingModal: FunctionComponent<ProcessingModalProps> = ({ onConfirm, open }) => {
  const { t } = useTranslation()
  const handleWindowCloseOrRefresh = (e: BeforeUnloadEvent): string | null => {
    e.preventDefault()
    e.returnValue = ''
    return e.returnValue
  }
  useEffect(() => {
    if (open) {
      window.addEventListener('beforeunload', handleWindowCloseOrRefresh)
      onConfirm()
    }
    return () => {
      window.removeEventListener('beforeunload', handleWindowCloseOrRefresh)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <PageCover justify="center" align="center" p="24px" isOpen={open} data-test="processing-modal">
      <Logo isSearchVariant={false} />
      <Grid justify="center" m="50px 0 0 0">
        <CircularLoader fontSize="60px" />
      </Grid>
      <Grid justify="center" m="28px 0 100px 0">
        <Text>{t('order.processing.message')}</Text>
      </Grid>
    </PageCover>
  )
}

export default ProcessingModal
